export const fr_translation =
{
  'zuora': {
    'title': 'Mode De Paiement',
    'CC-label': 'Payez en toute sécurité avec votre carte de crédit. Veuillez entrer les renseignements de votre carte de crédit pour continuer.',
    'button': 'Continuer pour passer en revue',
    // tslint:disable-next-line:max-line-length
    'error': '​​Une erreur de serveur temporaire est survenue lors du traitement de votre demande. Veuillez confirmer que l’information entrée est correcte. Si ce message s’affiche de nouveau, veuillez fermer l’app et réessayer plus tard.​',
    'tmna': {
      'consent-cc-one': 'N/A',
      'consent-cc-two': '',
      'consent-cc-three': '',
      'consent-cc-four': ''
    },
    'tdpr': {
      'consent-cc-one': 'N/A',
      'consent-cc-two': '',
      'consent-cc-three': '',
      'consent-cc-four': ''
    },
    'tci': {
      'consent-cc-one': 'En cochant cette case, j’autorise par la présente que les frais mensuels actuels et futurs soient portés à la carte de crédit que j’ai fournie, comme décrit ici et dans les ',
      'consent-cc-two': 'conditions d’utilisation des Services connectés',
      'consent-cc-three': ', y compris la politique de remboursement.',
      'consent-cc-four': ' Cette carte deviendra le mode de paiement par défaut.'
    }
  }
}
